import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col md:flex-row md:mr-auto md:ml-0 mx-auto" }
const _hoisted_3 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch, shallowRef } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import WithdrawTransactionFilterDialog from "@/components/dialogs/WithdrawTransactionFilterDialog.vue";
import ManualWithdrawCreateDialog from "@/components/dialogs/ManualWithdrawCreateDialog.vue";
import ButtonElement from "@/components/tools/ButtonElement.vue";
import { formatNumber, translate, timeDiff } from "@/utils/tools";

import router from "@/router";
import ConfirmRejectDialog from "@/components/dialogs/ConfirmRejectDialog.vue";
import ViewManualWithdrawDialog from "@/components/dialogs/ViewManualWithdrawDialog.vue";
import Toast from "@/components/tools/Toast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualWithdraw',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const createWithdrawModal = ref(false);
const isConfirmed = ref(false);
const form = ref();
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning:false
});
const isLoading = ref(false);
const viewButton = shallowRef(ButtonElement);

const columns = ref([
  {
    label: translate("messages.withdrawTransaction.user"),
    field: "user_phone",
    class: () => "hover:underline cursor-pointer",
    isFunction: true,
    function: (data: any) => {
      router.push(`/players/${data.user_id}`);
    },
    format: (data: any) =>
    data.user_name ? data.user_name : data.user_phone ? data.user_phone : data.user_id,
  },
  {
    label: translate("messages.withdrawTransaction.amount"),
    field: "amount",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.amount, 100),
    class: (data: any) =>
      Number(data.amount) < 0 ? "text-red-500" : "text-green-500",
  },
  {
    label: translate("messages.withdrawTransaction.dateRequested"),
    field: "requested_at",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.requested_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.withdrawTransaction.dateApproved"),
    field: "approve_at",
    sort: true,
    isSorted: false,
    format: (data: any) => data.approve_status.includes('PENDING') ? '-' : dayjs(data.approve_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.withdrawTransaction.status"),
    field: "status",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.approve_status ? data.approve_status : "-"),
    class: (data: any) => {
      let base = "text-white rounded ";
      data.approve_status === "REJECTED"
        ? (base += " bg-red-500 ")
        : data.approve_status.includes("SUCCESS")
        ? (base += " bg-green-500")
        : (base += " bg-yellow-500");

      return base;
    },
  },
  //   {
  //     label: translate("messages.withdrawTransaction.approvedBy"),
  //     field: "admin",
  //     align: "center",
  //     sort: true,
  //     isSorted: false,
  //     format: (data: any) => (data.approve_by ? data.approve_by : "-"),
  //   },
  {
    element: viewButton,
    field: "",
    align: "center",
    isFunction: true,
    format: (data: any) => "View",
    function: (data: any) => onViewWithdrawRequest(data),
    permission: "USER.MANUAL_WITHDRAW_APPROVE",
  },
]);

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["withdraws.updated_at", "DESC"]],
});

const filterForm = ref({
  user_phone: null,
  approve_status: null,
  approve_by: null,
  from: null,
  to: null,
});

const actionType = ref("");
const viewManualWithdrawDialog = ref(false);

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.approve_status = data.chanel;
    fetchPageData();
  }
};

const onViewWithdrawRequest = (data: any) => {
  form.value = data;
  viewManualWithdrawDialog.value = true;
};

const onOpenCreateManualWithdrawModal = () => {
  form.value = {
    requestId: Date.now().toString(),
    requestTs: Date.now(),
    operatorId: store.state.selectedOperator.operatorId,
    adminId: store.state.user.id,
    amount: null,
    userPhone: null,
  };
  createWithdrawModal.value = true;
};

const onCreateManualWithdraw = async () => {
  form.value.amount = form.value.amount.toString();
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/withdraw`,
      form.value
    );
    form.value = {};
    createWithdrawModal.value = false;
    fetchPageData();
  } catch (error) {
    form.value = {};
    createWithdrawModal.value = false;
    alert(error);
    fetchPageData();
  }
};

const onApproveWithdraw = async () => {
  isLoading.value = true;
  const payload = {
    requestId: form.value.id,
    requestTs: Date.now(),
    userId: `${form.value?.user_id}`,
    operatorId: form.value?.operator_id,
    amount: `${form.value?.amount / 100}`,
    adminId: `${store.state.user.id}`,
    withdrawId: form.value?.withdraw_id,
    approveMsg: form.value?.approveMsg,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/withdraw/approve`;
  try {
    await axios.post(url, payload);
    toastConfig.value = {
      message: "withdraw success",
      show: true,
      success: true,
      warning:false
    };
    await fetchPageData();
    viewManualWithdrawDialog.value = false;
    isLoading.value = false;
  } catch (error) {
    toastConfig.value = {
      message: error as "string",
      show: true,
      success: false,
      warning:false
    };
    isLoading.value = false;
    // alert(error);
  }
  isConfirmed.value = false;
};
const onRejectWithdraw = async () => {
  isLoading.value = true;
  const payload = {
    requestId: form.value.id,
    requestTs: Date.now(),
    userId: form.value?.user_id,
    username: `${form.value?.user_name}`,
    phoneNumber: `${form.value?.user_phone}`,
    appId: form.value?.app_id,
    operatorId: form.value?.operator_id,
    amount: `${form.value?.amount}`,
    channel: "MANUAL",
    refCode: form.value?.ref_code,
    withdrawId: form.value?.withdraw_id,
    timestamp: Date.now(),
    adminId: store.state.user.id,
    adminName: store.state.user.username,
    referenceRequest: form.value,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/transaction/withdraw-reject`;
  try {
    await axios.post(url, payload);
    toastConfig.value = {
      message: "reject transaction success",
      show: true,
      success: true,
      warning:false
    };
    await fetchPageData();
    viewManualWithdrawDialog.value = false;
    isLoading.value = false;
  } catch (error) {
    toastConfig.value = {
      message: error as "string",
      show: true,
      success: false,
      warning:false
    };
    isLoading.value = false;
    // alert(error);
  }
  isConfirmed.value = false;
};

const onConfirm = () => {
  if (actionType.value === "approve") {
    onApproveWithdraw();
  }
  if (actionType.value === "reject") {
    onRejectWithdraw();
  }
};
const onAction = async (type: string) => {
  actionType.value = type;
  isConfirmed.value = true;
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date Requested") attName = "seq_num";
  if (attName === "Date Approved") attName = "approve_at";
  if (attName === "Approved By") attName = "approve_by";
  if (attName === "Status") attName = "approve_status";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};

const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;
  const { user_phone, approve_status, approve_by, from, to } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    start_date: from
      ? dayjs(from).format("YYYY-MM-DD")
      : dayjs().add(-1, "month").format("YYYY-MM-DD"),
    end_date: to
      ? dayjs(to).add(1, "day").format("YYYY-MM-DD")
      : dayjs().add(1, "day").format("YYYY-MM-DD"),
    limit: rowsPerPage,
    offset: (page - 1) * rowsPerPage,
    type: "WITHDRAW",
    sort_by: sort,
    fillter: {
      user_phone: user_phone || null,
      approve_status: approve_status || "PENDING_APPROVE", // "PENDING_APPROVE"
      approve_by: approve_by || null, // "SYSTEM"
    },
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/withdraw-transactions`;
  // const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/withdraw-transactions`;
  const { result: data } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.manualDepositWithdraw.manualWithDraw')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DateSelector, { onSearch: onSearch }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (advanceFilterModal.value = true)),
            class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.withdrawTransaction.advanceFilter")), 1)
          ]),
          (_unref(store).state.user.permissions.includes('USER.MANUAL_WITHDRAW_CREATE'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: onOpenCreateManualWithdrawModal,
                class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-green-500"
              }, " Create Manual Withdraw "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(WithdrawTransactionFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(ManualWithdrawCreateDialog, {
      class: "z-10",
      show: createWithdrawModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((createWithdrawModal).value = $event)),
      form: form.value,
      "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((form).value = $event)),
      onCreate: onCreateManualWithdraw
    }, null, 8, ["show", "form"]),
    _createVNode(ViewManualWithdrawDialog, {
      class: "z-10",
      show: viewManualWithdrawDialog.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((viewManualWithdrawDialog).value = $event)),
      form: form.value,
      "onUpdate:form": _cache[7] || (_cache[7] = ($event: any) => ((form).value = $event)),
      loading: isLoading.value,
      "onUpdate:loading": _cache[8] || (_cache[8] = ($event: any) => ((isLoading).value = $event)),
      onApprove: onAction,
      onReject: onAction
    }, null, 8, ["show", "form", "loading"]),
    _createVNode(ConfirmRejectDialog, {
      title: `Do you want to ${actionType.value} this transaction?`,
      show: isConfirmed.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((isConfirmed).value = $event)),
      onSubmit: onConfirm
    }, null, 8, ["title", "show"]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"])
  ], 64))
}
}

})